import { zUpdateAgentForAdminEndpointInput } from '@/general/src/agent/routes/updateAgentForAdmin/input.js'
import { agentPermissionsOptions, canManageAgents } from '@/general/src/auth/can.js'
import { GeneralLayout } from '@/webapp/src/components/layout/GeneralLayout/index.js'
import { Checkboxesy, Switchy, Textfieldy, useFormy } from '@/webapp/src/lib/formy.js'
import { withPageWrapper } from '@/webapp/src/lib/pageWrapper.js'
import { adminAgentEditRoute } from '@/webapp/src/lib/routes.js'
import { trpc } from '@/webapp/src/lib/trpc.js'
import { Block, Button, Buttons, FormItems, Segment } from '@/webapp/src/lib/uninty.components.js'
import { useRouteParams } from '@/webapp/src/lib/useRoute.js'

export const AdminAgentEditPage = withPageWrapper({
  title: 'Редактирование агента',
  Layout: GeneralLayout,
  authorizedAdminsOnly: true,
  useQuery: () => {
    const { routeParams } = useRouteParams(adminAgentEditRoute)
    return trpc.getAgentForAdmin.useQuery({
      agentSn: +routeParams.agentSn,
    })
  },
  checkAccess: ({ ctx }) => canManageAgents(ctx.me.admin),
  setProps: ({ queryResult }) => ({
    agent: queryResult.data.agent,
  }),
})(({ agent }) => {
  const updateAgentForAdmin = trpc.updateAgentForAdmin.useMutation()
  const trpcUtils = trpc.useUtils()
  const formy = useFormy({
    initialValues: {
      agentId: agent.id,
      name: agent.name || '',
      email: agent.email,
      permissions: agent.permissions,
      banned: !!agent.bannedAt,
      ...{
        organizationSn: agent.organization?.sn || '',
      },
    },
    validationSchema: zUpdateAgentForAdminEndpointInput,
    onSubmit: async ({ valuesInput }) => {
      const res = await updateAgentForAdmin.mutateAsync({
        ...valuesInput,
      })
      trpcUtils.getAgentForAdmin.setData({ agentSn: res.agent.sn }, res)
    },
    successMessage: 'Агент обновлен',
  })
  return (
    <Block fcnw>
      <Segment title={`Агент #${agent.sn}`} size="m">
        <FormItems as="form" {...formy.formProps}>
          <Textfieldy
            label="Организация"
            {...formy.getFieldProps('organizationSn')}
            disabled
            hint={`${agent.organizationLabel} (Невозможно изменить)`}
          />
          <Textfieldy label="Имя" {...formy.getFieldProps('name')} />
          <Textfieldy label="Почта" {...formy.getFieldProps('email')} />
          <Checkboxesy label="Права" options={agentPermissionsOptions} {...formy.getFieldProps('permissions')} />
          <Switchy {...formy.getFieldProps('banned')} label="Заблокирован" optionLabel="Да" />
          <Buttons>
            <Button {...formy.buttonProps} type="submit">
              Сохранить
            </Button>
          </Buttons>
        </FormItems>
      </Segment>
    </Block>
  )
})
